import React, { useEffect, useRef, useState } from 'react'
import abcjs, { TuneObject } from 'abcjs';
import AbcAudioPlayer from './AbcAudioPlayer';
import { FaCog } from 'react-icons/fa';
import { SlSizeFullscreen } from 'react-icons/sl';

export default function ShowAbcTune({ analyzedTune }: { analyzedTune: abcjs.AnalyzedTune }) {
  const defaultInput = analyzedTune.abc || "X:1\nK:D\nD4|\n"
  const [abc, setAbc] = useState(defaultInput)
  const [mode, setMode] = useState<'edit' | 'view'>('view')
  const [transpose, setTranspose] = useState(0)
  const [origTuneObjectArray, setOrigTuneObjectArray] = useState<abcjs.TuneObjectArray | null>(null)
  const [tuneObjectArray, setTuneObjectArray] = useState<abcjs.TuneObjectArray | null>(null)
  const [error, setError] = useState<string | null>(null)
  const renderEl = useRef(null)

  useEffect(() => {
    if (!renderEl.current) return;
    try {
      if (!tuneObjectArray) {
        // initial render
        const tuneObjectArray = abcjs.renderAbc(
          renderEl.current,
          abc,
          {
            responsive: "resize",
          }
        )
        setOrigTuneObjectArray(tuneObjectArray)
        setTuneObjectArray(tuneObjectArray)
      } else {
        if (!origTuneObjectArray) return;
        var transposedAbcString = abcjs.strTranspose(abc, origTuneObjectArray, transpose)
        var transposedTuneObjArray = abcjs.renderAbc(
          renderEl.current,
          transposedAbcString,
          {
            responsive: "resize",
            afterParsing: (tune: TuneObject, tuneNumber: number, abc: string) => {
              console.log("afterParsing", tune);
              console.log('note', tune.lines[0].staff[0].voices[0][4]);
              tune.lines[0].staff[0].voices[0][4].decoration = ['myclass']
            }
          }
        )
        console.log(transposedAbcString.split('\n'));
        setTuneObjectArray(transposedTuneObjArray)
      }
      setError(null)
    } catch (e) {
      if (e instanceof Error) {
        setError(e.message)
      }
      console.error(e)
    }
  }, [renderEl.current, abc, transpose])

  return (
    <div style={{ margin: '0 auto' }} >
      {mode === 'edit' && (
        <div>
          <textarea
            value={abc}
            onChange={(e) => setAbc(e.target.value)}
            style={{ width: '100%', height: '200px', margin: '10px 0', borderRadius: '5px' }}
          />
          {error && <p style={{ color: 'red' }}>{error}</p>}
          &nbsp;
          Transpose by:
          <input type="number" value={transpose} onChange={(e) => setTranspose(parseInt(e.target.value))} maxLength={2} style={{ width: '40px', margin: '0 10px', borderRadius: '5px' }} />
          steps

        </div>
      )}

      {mode === 'edit' ? (
        <div onClick={() => setMode('view')}><FaCog /></div>
      ) : (
        <div onClick={() => setMode('edit')}> <FaCog /></div>
      )}
      <div id="show-abc-app" style={{ marginBottom: '15px' }}>
        <AbcAudioPlayer visualObj={tuneObjectArray} />
        <div className="rendered-abc-container" ref={renderEl} />
      </div>

    </div>
  )
}

